import { useEffect, useRef } from 'react';
import mermaid from 'mermaid';

interface MermaidProps {
  chart: string;
}

export function Mermaid({ chart }: MermaidProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      mermaid.initialize({
        startOnLoad: true,
        theme: 'default',
        securityLevel: 'loose',
      });

      mermaid.contentLoaded();
    }
  }, []);

  return (
    <div
      ref={containerRef}
      className="mermaid"
      style={{
        margin: '1.5rem 0',
        padding: '1rem',
        backgroundColor: '#f6f8fa',
        borderRadius: '6px',
        overflow: 'auto',
      }}
    >
      {chart}
    </div>
  );
}
